import { IUserDTO, UserDTO } from '@/dtos';
import { getMySelfAPI } from '@/services';
import { useQuery } from '@tanstack/vue-query';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useAuthStore = defineStore(
  'auth',
  () => {
    const isLoggedIn = ref<boolean>(false);
    const data = ref<string | undefined>(undefined);
    const token = ref<string | undefined>(undefined);
    const refresh = ref<string | undefined>(undefined);
    const me = computed(() => getMyself.data.value);
    const avatar = computed(() => me.value?.avatar?.url ?? '');
    const returnUrl = ref<string | undefined>();
    const showNav = ref<boolean>(true);
    const role = ref<string | undefined>(undefined);

    const getMyself = useQuery({
      queryKey: ['user-me'],
      queryFn: async (): Promise<IUserDTO> => {
        const ret = await getMySelfAPI();
        const user = new UserDTO(ret);
        return user;
      },
      enabled: computed(() => isLoggedIn.value),
    });

    function setUserToken(newValue: string) {
      token.value = newValue;
    }

    function setRefreshToken(newValue: string) {
      refresh.value = newValue;
    }

    function setData(newValue: string) {
      data.value = newValue;
    }

    function setRole(newValue: string) {
      role.value = newValue;
    }

    const isAdmin = computed(() => {
      return role.value === 'Admin';
    });
    const isUser = computed(() => {
      return role.value != null && role.value === 'Team';
    });

    async function logout() {
      isLoggedIn.value = false;
      token.value = undefined;
      data.value = undefined;
      role.value = undefined;
      token.value = undefined;
      refresh.value = undefined;
      showNav.value = true;
    }

    // "exported" elements
    return {
      isLoggedIn,
      getMyself,
      showNav,
      data,
      token,
      refresh,
      avatar,
      returnUrl,
      role,
      isAdmin,
      isUser,
      me,
      setUserToken,
      setRefreshToken,
      setData,
      setRole,
      logout,
    };
  },
  {
    // options
    persist: true,
  },
);
